import React, { TdHTMLAttributes } from 'react';

export interface VoxelTableCellProps
  extends Pick<
    TdHTMLAttributes<HTMLTableCellElement>,
    'align' | 'onClick' | 'colSpan' | 'onMouseDown'
  > {
  disabled?: boolean;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  paddingClass?: string;
  roundedTopLeft?: boolean; // This is required to keep rounding consistent when applying hover backgrounds etc.
  roundedTopRight?: boolean;
  roundedBottomLeft?: boolean;
  roundedBottomRight?: boolean;
}

export const VoxelTableCell: React.FC<VoxelTableCellProps> = ({
  children,
  align = 'left',
  onClick,
  disabled,
  colSpan,
  className,
  size = 'lg',
  roundedTopLeft,
  roundedTopRight,
  roundedBottomLeft,
  roundedBottomRight,
  ...tableCellProps
}) => {
  return (
    <td
      align={align}
      onClick={disabled ? () => {} : onClick}
      colSpan={colSpan}
      className={`
        ${size === 'lg' ? 'p-3' : ''}
        ${size === 'md' ? 'p-2' : ''}
        ${size === 'sm' ? 'p-1' : ''}
        font-sans font-normal
        ${roundedTopLeft ? 'rounded-tl-md' : ''}
        ${roundedTopRight ? 'rounded-tr-md' : ''}
        ${roundedBottomLeft ? 'rounded-bl-md' : ''}
        ${roundedBottomRight ? 'rounded-br-md' : ''}
        ${className}
      `}
      {...tableCellProps}
    >
      {children}
    </td>
  );
};

export default VoxelTableCell;
